export default __webpack_public_path__ + "static/media/mic.136c4058.svg";